const objRemoveEmpty = (obj) =>
  Object.entries(obj).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {});

export default objRemoveEmpty;
